import React from "react";
import { TextField } from "material-ui";
import { connect } from "react-algoliasearch-helper";

const BOX_STYLE = {
  borderRadius: "5px",
  backgroundColor: "#fff",
  padding: "0 10px",
  border: "1px solid #ccc",
  whiteSpace: "nowrap"
};

const ICON_STYLE = {
  marginRight: 8,
  fontSize: 14,
  verticalAlign: -1,
  color: "rgb(158, 158, 158)",
  transition: "color 0.5s ease"
};

const ICON_FOCUS_STYLE = {
  color: "rgb(2, 136, 209)"
};

const TEXT_FIELD_STYLE = {
  width: "calc(100% - 25px)",
  fontSize: 14,
  lineHeight: "20px",
  height: 40,
  marginBottom: -1
};

class SearchBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false
    };

    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onChange(e) {
    this.props.helper.setQuery(e.target.value).search();
  }

  onFocus(e) {
    this.setState({ focused: true });
    this.onChange(e);
    this.props.setShowResults(true);
  }

  onBlur(e) {
    this.setState({ focused: false });
    if (!this.props.parameters.query) {
      this.props.setShowResults(false);
    }
  }

  onKeyDown(e) {
    switch (e.which) {
      case 13: // ENTER
        this.props.openHitByIndex(this.props.selectedIndex);
        break;

      case 38: // UP ARROW
        this.props.setSelectedIndex(this.props.selectedIndex - 1);
        break;

      case 40: // DOWN ARROW
        this.props.setSelectedIndex(this.props.selectedIndex + 1);
        break;

      case 27: // ESCAPE
        this.field.blur();
        this.props.setShowResults(false);
        break;

      default:
        // fall through
        return;
    }

    // A case was triggered
    e.preventDefault();
    e.stopPropagation();
  }

  componentWillReceiveProps(props) {
    if (props.showResults && !this.state.focused && this.field) {
      this.field.focus();
      this.field.handleInputFocus({ target: this.field.getInputNode() });
    }
  }

  render() {
    let { helper, parameters } = this.props,
      { focused } = this.state;

    return (
      <div style={BOX_STYLE}>
        <label htmlFor="GlobalSearchBox--TextField">
          <span
            style={Object.assign({}, ICON_STYLE, focused && ICON_FOCUS_STYLE)}
            className="icon-search"
          />
        </label>
        <TextField
          style={TEXT_FIELD_STYLE}
          tabIndex={1}
          id="GlobalSearchBox--TextField"
          ref={r => {
            this.field = r;
          }}
          value={parameters.query}
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onKeyDown={this.onKeyDown}
          autoComplete="off"
          hintText="Type to search everything..."
        />
      </div>
    );
  }
}

export default connect(state => ({ parameters: state.searchParameters }))(
  SearchBox
);



// WEBPACK FOOTER //
// ./src/app/components/partials/search/global-search-box.jsx